<template>
  <div class="menubar-navigation">

    <router-link to="/dayplanner" class="nav-menu-item">
      <font-awesome-icon class="nav-menu-item-icon" icon="calendar-alt" size="2x" /> Plan day
    </router-link>

    <el-popover
      placement="right-start"
      v-model="popover_visible"
      width="200"
      popper-class="nav-menu-popover"
      trigger="click">

      <div v-if="popover_visible">
        <template v-for="menu_item in menuData">

          <div
            v-if="menu_item.divided"
            class="menu-divider"
            :key="'divider-' + menu_item.href" />

          <a
            v-if="menu_item.onClick "
            @click="menu_item.onClick "
            :key="menu_item.href"
            :class="{
              'd-block el-dropdown-menu__item': true,
            }">
            <font-awesome-icon :icon="menu_item.icon" />
            {{menu_item.title}}
          </a>

          <router-link
            v-else
            @click="menu_item.onClick ? menu_item.onClick($event) : true"
            :key="menu_item.href"
            :to="menu_item.href"
            :class="{
              'd-block el-dropdown-menu__item': true,
              'is-active': $route.path.startsWith( menu_item.href ) /* TODO */
            }">
            <font-awesome-icon :icon="menu_item.icon" />
            {{menu_item.title}}
          </router-link>

        </template>
        <!-- <pre>{{menuData}}</pre> -->

        <el-popover
          v-if="show_developer_toolbar"
          placement="right"
          width="400"
          popper-class="nav-menu-popover"
          trigger="click">

          <DeveloperMenu />

          <div
            slot="reference"
            :class="{
              'd-block el-dropdown-menu__item': true,
            }">
            <font-awesome-icon icon="wrench" />
            Developer Menu
          </div>

        </el-popover>

      </div>

      <font-awesome-icon slot="reference" class="nav-menu-icon" icon="ellipsis-h" size="2x" />
    </el-popover>

  </div>
</template>

<script>
import {
  BUGTRACKER_TARGET_TASK_IDS,
  FEATURE_SHOW_DEVELOPER_TOOLBAR } from '@/features'

import DeveloperMenu from '@/layouts/Elements/DeveloperMenu.vue'

// xTODO: fix report bug
// xTODO: developer menu

// TODO: help
// TODO: keyboard shortcuts

export default {
  data: () => ({
    popover_visible: false,
    show_developer_toolbar: FEATURE_SHOW_DEVELOPER_TOOLBAR,
  }),
  computed: {

    menuData() {
      const menu = [];

      menu.push({
        href:  "/monthplanner",
        title: "Plan month",
        icon:  "calendar-alt",
      });

      menu.push({
        href:  "/goals",
        title: "Goals",
        icon:  "bullseye",
      });

      menu.push({
        href:  "/challenges",
        title: "Challenges",
        icon:  'trophy',
      });

      menu.push({
        href:  "/calendar/manage-time-and-priorities",
        title: "Manage Time",
        icon:  "clock"
      });

      menu.push({
        href:  "/commitments",
        title: "Commitments",
        icon:  "sliders-h"
      });

      menu.push({
        href: "/sequences",
        title: "Routines",
        icon: "sequence-icon"
      });

      menu.push({
        href: "/ideas",
        title: "Ideas",
        icon: "lightbulb"
      });

      let { goalId, uid, taskId } = BUGTRACKER_TARGET_TASK_IDS;
      menu.push({
        href:  `/goal/${goalId}/member/${uid}/task/${taskId}`,
        title: "Report Bug",
        icon:  "bug",
        divided: true,
        onClick: ($event) => {
          $event.preventDefault();
          $event.stopPropagation();
          this.$root.showNewModal('bugtracker');
        },
      });

      menu.push({
        href: "/feature-request",
        title: "Feature request",
        icon: "vote-yea"
      });

      /*
      if ( ENABLE_VISIONBOARD ) {
        const visionboards = {
          title: 'Visionboards',
          href: "/visionboards",
          icon: "camera-retro",
          child: []
        }
        visionboards.child.push({
          href: '/visionboard/1',
          component: InlineVisionboard,
          attrs: {
            visionboardPreview: this.visionboardPreview
          }
        });
        menu.push(visionboards)
      }
      */

      return menu
    },
  },
  components: {
    DeveloperMenu,
  }
};
</script>
